import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
	getProducts: null,
	getProductsDone: ['products'],
	getProductsError: ['errorMessage'],
	addProduct: ['majorId', 'form', 'history'],
	addProductDone: ['message'],
	addProductError: ['errorMessage'],
	deleteProduct: ['productId'],
	deleteProductDone: ['message'],
	deleteProductError: ['errorMessage'],
	editProduct: ['majorId', 'form', 'history'],
	editProductDone: ['message'],
	editProductError: ['errorMessage'],
	setProduct: ['product'],
});

export const INITIAL_STATE = {
	loading: false,
	message: '',
	errorMessage: '',
	products: [],
	product: {},
};

export const ProductsTypes = Types;
export default Creators;

const fetchRequest = state => ({
	...state,
	loading: true,
	message: '',
})

const getProductsDone = ( state, { products }) => ({
	...state,
	products,
	loading: false
})

const getProductsError = ( state, { message }) => ({
	...state,
	loading: false,
	errorMessage: message,
})

const addProductDone = (state, { message }) => ({
	...state,
	message: 'Producto añadido exitosamente',
	loading: false,
})

const addProductError = (state, { errorMessage }) => ({
	...state,
	errorMessage,
	loading: false,
})

const deleteProductDone = (state, { message }) => ({
	...state,
	message: 'Producto eliminado exitosamente',
	loading: false,
})

const deleteProductError = (state, { errorMessage }) => ({
	...state,
	errorMessage: 'Hubo un problema al eliminar el producto',
	loading: false,
})

const showMessage = (state, { message }) => ({
	...state,
	message,
	loading: false,
})

const errorMessage = (state, { errorMessage }) => ({
	...state,
	errorMessage,
	loading: false,
})

const setProduct = (state, { product }) => ({
	...state,
	product,
})

export const reducer = createReducer(INITIAL_STATE, {
	[Types.GET_PRODUCTS]: fetchRequest,
	[Types.GET_PRODUCTS_DONE]: getProductsDone,
	[Types.GET_PRODUCTS_ERROR]: getProductsError,
	[Types.ADD_PRODUCT]: fetchRequest,
	[Types.ADD_PRODUCT_DONE]: addProductDone,
	[Types.ADD_PRODUCT_ERROR]: addProductError,
	[Types.DELETE_PRODUCT]: fetchRequest,
	[Types.DELETE_PRODUCT_DONE]: deleteProductDone,
	[Types.DELETE_PRODUCT_ERROR]: deleteProductError,
	[Types.EDIT_PRODUCT]: fetchRequest,
	[Types.EDIT_PRODUCT_DONE]: showMessage,
	[Types.EDIT_PRODUCT_ERROR]: errorMessage,
	[Types.SET_PRODUCT]: setProduct,
});